import { CA_SUBDIVISION_NAMES, US_SUBDIVISION_NAMES } from '@cx-web/domain-types';

import { type StateCodeCA, type StateCodeUS, validStateCodesCA, validStateCodesUS } from '@cx-modules/constants';
import { type StateCode } from '@cx-modules/types';

export type { StateCode };

export interface IStateObject {
  isSelected?: boolean;
  stateCode: StateCode;
  stateName: string;
  url?: string;
}

export function getStateName(code: StateCode): string | undefined {
  return US_SUBDIVISION_NAMES[code as StateCodeUS] ?? CA_SUBDIVISION_NAMES[code as StateCodeCA];
}

export function isUSState(code: string): code is StateCodeUS {
  return validStateCodesUS.includes(code as StateCodeUS);
}

export function getDefaultState(stateCode: string): StateCode {
  if (validStateCodesUS.includes(stateCode as StateCodeUS)) {
    return 'NJ';
  }
  if (validStateCodesCA.includes(stateCode as StateCodeCA)) {
    return 'ON';
  }
  return 'NJ';
}
